import { BinaryFilter, Filter, LogicalAndFilter, LogicalOrFilter } from '@cubejs-client/core';

const isLogicalAndFilter = (filter: Filter): filter is LogicalAndFilter => 'and' in filter;

const isLogicalOrFilter = (filter: Filter): filter is LogicalOrFilter => 'or' in filter;

const isBinaryFilter = (filter: Filter): filter is BinaryFilter => 'member' in filter && 'operator' in filter;

const mapFilterTree = (filter: Filter, transformBinary: (binaryFilter: BinaryFilter) => Filter): Filter => {
  if (isLogicalAndFilter(filter)) {
    return {
      and: filter.and.map(nestedFilter => mapFilterTree(nestedFilter, transformBinary)),
    };
  }

  if (isLogicalOrFilter(filter)) {
    return {
      or: filter.or.map(nestedFilter => mapFilterTree(nestedFilter, transformBinary)),
    };
  }

  if (isBinaryFilter(filter)) {
    return transformBinary(filter);
  }

  return filter;
};

export const appendValueToEqualsFilters = (filter: Filter, additionalValue?: string): Filter => {
  if (!additionalValue) return filter;

  return mapFilterTree(filter, binaryFilter => {
    if (binaryFilter.operator !== 'equals') {
      return binaryFilter;
    }

    return {
      ...binaryFilter,
      values: [...binaryFilter.values, additionalValue],
    };
  });
};
